export const localeConstants = {
  "in-hi": {
    DETAILS: "वेबसाइट पर जाएँ",
    SUBMIT: "प्रस्तुत करें",
    LOCATION: "जगह",
    DISTANCE: "दूरी",
    SEARCH: "खोज",
    CLEAR: "स्पष्ट",
    TRAINER: "प्रशिक्षकों",
    MEDITATIONCENTER: "ध्यान केंद्र",
    SEND: "एक संदेश भेजो",
    KM: "किलोमीटर",
    MILES: "मील",
    FORMFIELDS: {
      FORMMESSAGE:
        "आपका संदेश हियरस्पॉट्स टीम द्वारा सत्यापन के बाद भेजा जाएगा।",
      NAME: "नाम",
      EMAIL: "मेल पता",
      PHONE: "फ़ोन नंबर",
      MESSAGE: "आपका संदेश",
      DISCLAIMER:
        "मैं करने के लिए सहमत हूं <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>नियम एवं शर्तें</a>",
      ERRORMSGS: {
        DISCLAIMER: "कृपया नियम व शर्तों की सहमति दें",
        PHONE: "एक वैध फ़ोन नंबर दर्ज करें",
        EMAIL: "ईमेल खाली नहीं होना चाहिए",
        EMAILINVALID: "अमान्य ईमेल",
        NAME: "प्रविष्ट नाम में अमान्य अक्षर हैं",
        NAMEEMPTY: "नाम खाली नहीं होना चाहिए",
      },
      PLACEHOLDER: {
        MESSAGE: "अपना संदेश दर्ज करें...",
        LOCATION: "स्थान दर्ज करें",
        EMAIL: "ईमेल दर्ज करें",
        NAME: "नाम दर्ज करें",
      },
    },
    GETDIRECTIONS: "दिशा प्राप्त करें",
    ADDRESS: "पता",
    TIMINGS: "समय",
    EMAIL: "ईमेल",
    PHONE: "फ़ोन",
    LOCATIONACCESSMSG:
      "कृपया अपने पास के प्रशिक्षकों और ध्यान केंद्रों की सूची देखने के लिए 'स्थान पहुंच' सक्षम करें।",
    Re_captcha_verification: "कृपया reCAPTCHA सत्यापन पूरा करें।",
    Heartspot_form_message:
      "आपका संदेश भेज दिया गया है। हार्टस्पॉट्स टीम द्वारा सत्यापन के बाद आपको सूचित किया जाएगा।",
    NODATAMSG: "इस स्थान के लिए कोई प्रशिक्षक या केंद्र उपलब्ध नहीं है",
    NOTRAINERMSG: "इस स्थान के लिए कोई प्रशिक्षक उपलब्ध नहीं है",
    NOCENTERMSG: "इस स्थान के लिए कोई केंद्र उपलब्ध नहीं है",
  },
  "in-mr": {
    DETAILS: "वेबसाइटला भेट द्या",
    SUBMIT: "सबमिट करा",
    LOCATION: "स्थान",
    DISTANCE: "अंतर",
    SEARCH: "शोध",
    CLEAR: "साफ करा",
    TRAINER: "प्रशिक्षक",
    MEDITATIONCENTER: "ध्यान केंद्रे",
    SEND: "संदेश पाठवा",
    KM: "किमी",
    MILES: "मैल",
    FORMFIELDS: {
      FORMMESSAGE:
        "तुमचा संदेश हियरस्पॉट्स टीमकडून पडताळणी केल्यानंतर पाठवला जाईल.",
      NAME: "नाव",
      EMAIL: "ईमेल पत्ता",
      PHONE: "फोन नंबर",
      MESSAGE: "तुमचा संदेश",
      DISCLAIMER:
        "मी सहमत आहे <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>अटी आणि शर्ती</a>",
      ERRORMSGS: {
        DISCLAIMER: "कृपया अटी आणि शर्तींशी सहमत व्हा.",
        PHONE: "वैध फोन नंबर एंटर करा",
        EMAIL: "ईमेल रिकामा नसावा",
        EMAILINVALID: "चुकीचा ईमेल",
        NAME: "प्रविष्ट केलेल्या नावात अवैध वर्ण आहेत.",
        NAMEEMPTY: "नाव रिकामे नसावे",
      },
      PLACEHOLDER: {
        MESSAGE: "तुमचा मेसेज एंटर करा...",
        LOCATION: "स्थान प्रविष्ट करा",
        EMAIL: "ईमेल एंटर करा",
        NAME: "नाव एंटर करा",
      },
    },
    GETDIRECTIONS: "दिशानिर्देश मिळवा",
    ADDRESS: "पत्ता",
    TIMINGS: "वेळ",
    EMAIL: "ईमेल",
    PHONE: "फोन",
    LOCATIONACCESSMSG:
      "तुमच्या जवळील प्रशिक्षक आणि ध्यान केंद्रांची यादी पाहण्यासाठी कृपया 'स्थान प्रवेश' सक्षम करा.",
    Re_captcha_verification: "कृपया reCAPTCHA पडताळणी पूर्ण करा.",
    Heartspot_form_message:
      "तुमचा मेसेज पाठवला गेला आहे. हार्टस्पॉट्स टीमने पडताळणी केल्यानंतर तुम्हाला सूचित केले जाईल..",
    NODATAMSG: "या स्थानासाठी कोणतेही प्रशिक्षक किंवा केंद्रे उपलब्ध नाहीत",
    NOTRAINERMSG: "या स्थानासाठी कोणतेही प्रशिक्षक उपलब्ध नाहीत.",
    NOCENTERMSG: "या स्थानासाठी कोणतेही केंद्र उपलब्ध नाहीत.",
  },
  lv: {
    DETAILS: "Vist vietne",
    SUBMIT: "Iesniegt",
    LOCATION: "Atrašanās vieta",
    DISTANCE: "Attālums",
    SEARCH: "Meklēt",
    CLEAR: "Notīrīt",
    TRAINER: "Treneri",
    MEDITATIONCENTER: "Meditācijas centri",
    SEND: "Nosūtīt ziņu",
    KM: "KM",
    MILES: "Jūdzes",
    FORMFIELDS: {
      FORMMESSAGE: "Jūsu ziņa tiks nosūtīta pēc Hearspots komandas pārbaudes.",
      NAME: "Vārds",
      EMAIL: "E-pasta adrese",
      PHONE: "Telefona numurs",
      MESSAGE: "Jūsu ziņa",
      DISCLAIMER:
        "Es piekrītu <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>noteikumiem un nosacījumiem</a>",
      ERRORMSGS: {
        DISCLAIMER: "Lūdzu, piekrītiet noteikumiem un nosacījumiem",
        PHONE: "Ievadiet derīgu telefona numuru",
        EMAIL: "E-pasts nedrīkst būt tukšs",
        EMAILINVALID: "Nederīgs e-pasts",
        NAME: "Ievadītajā vārdā ir nederīgas rakstzīmes",
        NAMEEMPTY: "Vārds nedrīkst būt tukšs",
      },
      PLACEHOLDER: {
        MESSAGE: "Ievadiet savu ziņu...",
        LOCATION: "Ievadiet atrašanās vietu",
        EMAIL: "Ievadiet e-pastu",
        NAME: "Ievadiet vārdu",
      },
    },
    GETDIRECTIONS: "Iegūt norādes",
    ADDRESS: "Adrese",
    TIMINGS: "Darba laiks",
    EMAIL: "E-pasts",
    PHONE: "Telefons",
    LOCATIONACCESSMSG:
      "Lūdzu, aktivizējiet 'Atrašanās vietas piekļuvi', lai redzētu tuvumā esošo treneru un meditācijas centru sarakstu.",
    Re_captcha_verification: "Lūdzu, aizpildiet reCAPTCHA verifikāciju.",
    Heartspot_form_message:
      "Jūsu ziņa ir nosūtīta. Pēc heartspots komandas pārbaudes jūs tiksiet informēts.",
    NODATAMSG: "Šai vietai nav pieejami treneri vai centri",
    NOTRAINERMSG: "Šai vietai nav pieejams neviens treneris",
    NOCENTERMSG: "Šai atrašanās vietai nav pieejams neviens centrs",
  },
  si: {
    DETAILS: "Poglej podrobnosti",
    SUBMIT: "POŠLJI",
    LOCATION: "Lokacija",
    DISTANCE: "Razdalja",
    SEARCH: "Iskanje",
    CLEAR: "ČISTO",
    TRAINER: "TRENAŽERJI",
    MEDITATIONCENTER: "MEDITACIJSKI CENTRI",
    SEND: "POŠLJI SPOROČILO",
    KM: "KM",
    MILES: "MILE",
    FORMFIELDS: {
      FORMMESSAGE:
        "Vaše sporočilo bo poslano po preverjanju s strani ekipe Hearspots.",
      NAME: "Ime",
      EMAIL: "E-poštni naslov",
      PHONE: "Telefonska številka",
      MESSAGE: "Vaše sporočilo",
      DISCLAIMER:
        "Strinjam se z <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>Pogoji in določila</a>",
      ERRORMSGS: {
        DISCLAIMER: "Prosimo, da se strinjate s pogoji",
        PHONE: "Vnesite veljavno telefonsko številko",
        EMAIL: "E-pošta ne sme biti prazna",
        EMAILINVALID: "Neveljaven e-poštni naslov",
        NAME: "Vneseno ime vsebuje neveljavne znake",
        NAMEEMPTY: "Ime ne sme biti prazno",
      },
      PLACEHOLDER: {
        MESSAGE: "Vnesite svoje sporočilo ...",
        LOCATION: "Vnesite lokacijo",
        EMAIL: "Vnesite e-pošto",
        NAME: "Vnesite ime",
      },
    },
    GETDIRECTIONS: "Pridobite navodila",
    ADDRESS: "Naslov",
    TIMINGS: "Časi",
    EMAIL: "E-pošta",
    PHONE: "Telefon",
    LOCATIONACCESSMSG:
      "Omogočite 'Dostop do lokacije', če si želite ogledati seznam trenerjev in centrov za meditacijo v vaši bližini.",
    Re_captcha_verification: "Dokončajte preverjanje reCAPTCHA.",
    Heartspot_form_message:
      "Vaše sporočilo je bilo poslano. Po preverjanju s strani ekipe heartspots boste obveščeni.",
    NODATAMSG: "Za to lokacijo ni na voljo nobenih trenerjev ali centrov",
    NOTRAINERMSG: "Za to lokacijo ni na voljo nobenih trenerjev",
    NOCENTERMSG: "Za to lokacijo ni na voljo nobenega centra",
  },
  rs: {
    DETAILS: "Погледај детаље",
    SUBMIT: "СУБМИТ",
    LOCATION: "Локација",
    DISTANCE: "Удаљеност",
    SEARCH: "Тражи",
    CLEAR: "ЦЛЕАР",
    TRAINER: "ТРАИНЕРС",
    MEDITATIONCENTER: "МЕДИТАЦИЈСКИ ЦЕНТРИ",
    SEND: "ПОШАЉИТЕ ПОРУКУ",
    KM: "КМ",
    MILES: "МИЛЕС",
    FORMFIELDS: {
      FORMMESSAGE:
        "Ваша порука ће бити послата након верификације од стране Хеарспотс тима.",
      NAME: "Име",
      EMAIL: "Адреса е-поште",
      PHONE: "Број телефона",
      MESSAGE: "Ваша порука",
      DISCLAIMER:
        "Слажем се са <a href='https://heartfulness.org/rs/terms' target='_blank' rel='noreferrer'>Услови &amp; Услови</a>",
      ERRORMSGS: {
        DISCLAIMER: "Прихватите услове и одредбе",
        PHONE: "Унесите важећи број телефона",
        EMAIL: "Имејл не треба да буде празан",
        EMAILINVALID: "Неважећа адреса е-поште",
        NAME: "Унесено име има неважеће знакове",
        NAMEEMPTY: "Име не треба да буде празно",
      },
      PLACEHOLDER: {
        MESSAGE: "Унесите своју поруку...",
        LOCATION: "Унесите локацију",
        EMAIL: "Унесите емаил",
        NAME: "Унесите име",
      },
    },
    GETDIRECTIONS: "ДОБИТИ УПУТСТВА",
    ADDRESS: "Адреса",
    TIMINGS: "Тајминг",
    EMAIL: "Емаил",
    PHONE: "Телефон",
    LOCATIONACCESSMSG:
      "Омогућите „Приступ локацији“ да бисте видели листу сертификованих тренера и центара за медитацију у вашој близини.",
    Re_captcha_verification: "Довршите реЦАПТЦХА верификацију.",
    Heartspot_form_message:
      "Ваша порука је послата. Након верификације од стране хеартспотс тима, бићете обавештени.",
    NODATAMSG: "Нема доступних тренера или центара за ову локацију",
    NOTRAINERMSG: "Нема доступних тренера за ову локацију",
    NOCENTERMSG: "Нема доступних центара за ову локацију",
  },
  hr: {
    DETAILS: "Pogledaj detalje",
    SUBMIT: "POŠALJI",
    LOCATION: "Mjesto",
    DISTANCE: "Udaljenost",
    SEARCH: "Pretraživanje",
    CLEAR: "JASAN",
    TRAINER: "TRENERICE",
    MEDITATIONCENTER: "CENTRI ZA MEDITACIJU",
    SEND: "POŠALJI PORUKU",
    KM: "KM",
    MILES: "MILE",
    FORMFIELDS: {
      FORMMESSAGE:
        "Vaša će poruka biti poslana nakon provjere od strane Hearspots tima.",
      NAME: "Ime",
      EMAIL: "E-mail adresa",
      PHONE: "Broj telefona",
      MESSAGE: "Vaša poruka",
      DISCLAIMER:
        "Slažem se s <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>Terms &amp; Uvjeti</a>",
      ERRORMSGS: {
        DISCLAIMER: "Molimo prihvatite uvjete i odredbe",
        PHONE: "Unesite važeći broj telefona",
        EMAIL: "Email ne smije biti prazan",
        EMAILINVALID: "Nevažeća e-pošta",
        NAME: "Uneseno ime ima nevažeće znakove",
        NAMEEMPTY: "Ime ne smije biti prazno",
      },
      PLACEHOLDER: {
        MESSAGE: "Unesite svoju poruku...",
        LOCATION: "Unesite lokaciju",
        EMAIL: "Unesite email",
        NAME: "Unesite ime",
      },
    },
    GETDIRECTIONS: "DOBITI UPUTE",
    ADDRESS: "Adresa",
    TIMINGS: "Timings",
    EMAIL: "E-mail",
    PHONE: "Telefon",
    LOCATIONACCESSMSG:
      "Omogućite 'Pristup lokaciji' kako biste vidjeli popis certificiranih trenera i centara za meditaciju u vašoj blizini.",
    Re_captcha_verification: "Dovršite reCAPTCHA provjeru.",
    Heartspot_form_message:
      "Vaša poruka je poslana. Nakon provjere od strane Heartspots tima, bit ćete obaviješteni.",
    NODATAMSG: "Za ovu lokaciju nema dostupnih trenera ili centara",
    NOTRAINERMSG: "Za ovu lokaciju nema dostupnih trenera",
    NOCENTERMSG: "Nema dostupnih centara za ovu lokaciju",
  },
  jp: {
    DETAILS: "ウェブサイトをご覧ください",
    SUBMIT: "送信",
    LOCATION: "場所",
    DISTANCE: "距離",
    SEARCH: "検索",
    CLEAR: "クリア",
    TRAINER: "トレーナー",
    MEDITATIONCENTER: "瞑想センター",
    SEND: "メッセージを送信",
    KM: "KM",
    MILES: "マイル",
    FORMFIELDS: {
      FORMMESSAGE: "メッセージはHeartspotsチームによる確認後に送信されます。",
      NAME: "名前",
      EMAIL: "メールアドレス",
      PHONE: "電話番号",
      MESSAGE: "メッセージ",
      DISCLAIMER:
        "に同意します <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>利用規約</a>",
      ERRORMSGS: {
        DISCLAIMER: "利用規約に同意してください",
        PHONE: "有効な電話番号を入力してください",
        EMAIL: "メールアドレスを入力してください",
        EMAILINVALID: "無効なメールアドレスです",
        NAME: "無効な文字が含まれています",
        NAMEEMPTY: "名前を入力してください",
      },
      PLACEHOLDER: {
        MESSAGE: "メッセージを入力してください...",
        LOCATION: "場所を入力",
        EMAIL: "メールアドレスを入力",
        NAME: "名前を入力",
      },
    },
    GETDIRECTIONS: "ルートを表示",
    ADDRESS: "住所",
    TIMINGS: "時間",
    EMAIL: "メールアドレス",
    PHONE: "電話番号",
    LOCATIONACCESSMSG:
      "近くの認定トレーナーや瞑想センターを表示するには、「位置情報アクセス」を有効にしてください。",
    Re_captcha_verification: "reCAPTCHA認証を完了してください。",
    Heartspot_form_message:
      "メッセージが送信されました。Heartspotsチームによる確認後に通知されます。",
    NODATAMSG: "この場所にはトレーナーまたはセンターがありません",
    NOTRAINERMSG: "この場所にはトレーナーがいません",
    NOCENTERMSG: "この場所にはセンターがありません",
  },
  "no-no": {
    DETAILS: "SE DETALJER",
    SUBMIT: "SEND inn",
    LOCATION: "Sted",
    DISTANCE: "Avstand",
    SEARCH: "Søk",
    CLEAR: "KLAR",
    TRAINER: "TRENERE",
    MEDITATIONCENTER: "MEDITASJONSSENTER",
    SEND: "SEND EN MELDING",
    KM: "KM",
    MILES: "MILES",
    FORMFIELDS: {
      FORMMESSAGE:
        "Meldingen din vil bli sendt etter bekreftelse av Hearspots-teamet.",
      NAME: "Navn",
      EMAIL: "E-postadresse",
      PHONE: "Telefonnummer",
      MESSAGE: "Din melding",
      DISCLAIMER:
        "Jeg er enig i <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>Vilkår &amp; Forhold</a>",
      ERRORMSGS: {
        DISCLAIMER: "Vennligst godta vilkårene og betingelsene",
        PHONE: "Skriv inn et gyldig telefonnummer",
        EMAIL: "E-post skal ikke være tom",
        EMAILINVALID: "Ugyldig e-post",
        NAME: "Det angitte navnet har ugyldige tegn",
        NAMEEMPTY: "Navn skal ikke være tomt",
      },
      PLACEHOLDER: {
        MESSAGE: "Skriv inn meldingen din...",
        LOCATION: "Angi plassering",
        EMAIL: "Skriv inn e-post",
        NAME: "Skriv inn navn",
      },
    },
    GETDIRECTIONS: "FÅ RETNINGSLINJER",
    ADDRESS: "Adresse",
    TIMINGS: "Tidspunkter",
    EMAIL: "E-post",
    PHONE: "Telefon",
    LOCATIONACCESSMSG:
      "Aktiver 'Location Access' for å se listen over sertifiserte trenere og meditasjonssenter i nærheten av deg.",
    Re_captcha_verification: "Fullfør reCAPTCHA-verifiseringen.",
    Heartspot_form_message:
      "Meldingen din er sendt. Etter verifisering av heartspots-teamet vil du bli varslet.",
    NODATAMSG: "Ingen trenere eller sentre tilgjengelig for dette stedet",
    NOTRAINERMSG: "Ingen trenere tilgjengelig for dette stedet",
    NOCENTERMSG: "Ingen sentre tilgjengelig for dette stedet",
  },
  default: {
    SUBMIT: "SUBMIT",
    LOCATION: "Location",
    DISTANCE: "Distance",
    SEARCH: "Search",
    CLEAR: "CLEAR",
    TRAINER: "TRAINERS",
    MEDITATIONCENTER: "MEDITATION CENTERS",
    SEND: "SEND A MESSAGE",
    DETAILS: "Visit Website",
    KM: "KM",
    MILES: "MILES",
    FORMFIELDS: {
      FORMMESSAGE:
        "Your message will be sent after verification by Hearspots team.",
      NAME: "Name",
      EMAIL: "Email address",
      PHONE: "Phone Number",
      MESSAGE: "Your Message",
      DISCLAIMER:
        "I agree to the <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>Terms &amp; Conditions</a>",
      ERRORMSGS: {
        DISCLAIMER: "Please agree to the terms and conditions",
        PHONE: "Enter a valid phone number",
        EMAIL: "Email should not be empty",
        EMAILINVALID: "Invalid Email",
        NAME: "Entered name has invalid characters",
        NAMEEMPTY: "Name should not be empty",
      },
      PLACEHOLDER: {
        MESSAGE: "Enter your message...",
        LOCATION: "Enter Location",
        EMAIL: "Enter email",
        NAME: "Enter name",
      },
    },
    GETDIRECTIONS: "GET DIRECTIONS",
    ADDRESS: "Address",
    TIMINGS: "Timings",
    EMAIL: "Email",
    PHONE: "Phone",
    LOCATIONACCESSMSG:
      "Please enable the 'Location Access' to see the list of Certified Trainers and Meditation centre's near you.",
    Re_captcha_verification: "Please complete the reCAPTCHA verification.",
    Heartspot_form_message:
      "Your message has been sent. After verification by heartspots team you will be notified.",
    NODATAMSG: "No Trainers or Centers available for this location",
    NOTRAINERMSG: "No Trainers available for this location",
    NOCENTERMSG: "No Centers available for this location",
  },
  ua: {
    DETAILS: "Переглянути деталі",
    SUBMIT: "ПОДАТИ",
    LOCATION: "Розташування",
    DISTANCE: "Відстань",
    SEARCH: "Пошук",
    CLEAR: "ЯСНО",
    TRAINER: "ТРЕНЕРИ",
    MEDITATIONCENTER: "МЕДИТАЦІЙНІ ЦЕНТРИ",
    SEND: "НАДІСЛАТИ ПОВІДОМЛЕННЯ",
    KM: "KM",
    MILES: "МІЛІ",
    FORMFIELDS: {
      FORMMESSAGE:
        "Ваше повідомлення буде надіслано після перевірки командою Hearspots.",
      NAME: "Ім'я",
      EMAIL: "Адреса електронної пошти",
      PHONE: "Номер телефону",
      MESSAGE: "Ваше повідомлення",
      DISCLAIMER:
        "Я згоден на <a href='https://heartfulness.org/global/terms' target='_blank' rel='noreferrer'>Терміни &amp; Умови</a>",
      ERRORMSGS: {
        DISCLAIMER: "Будь ласка, погодьтеся з умовами",
        PHONE: "Введіть дійсний номер телефону",
        EMAIL: "Поле електронної пошти не повинно бути порожнім",
        EMAILINVALID: "Недійсна електронна адреса",
        NAME: "Введене ім'я містить недійсні символи",
        NAMEEMPTY: "Назва не повинна бути пустою",
      },
      PLACEHOLDER: {
        MESSAGE: "Введіть своє повідомлення...",
        LOCATION: "Введіть місцезнаходження",
        EMAIL: "Введіть адресу електронної пошти",
        NAME: "Введіть ім'я",
      },
    },
    GETDIRECTIONS: "ОТРИМАТИ МАРШРУТ",
    ADDRESS: "Адреса",
    TIMINGS: "Таймінг",
    EMAIL: "Електронна пошта",
    PHONE: "Телефон",
    LOCATIONACCESSMSG:
      "Увімкніть 'Доступ до місцезнаходження', щоб переглянути список сертифікованих тренерів і центрів медитації поблизу вас.",
    Re_captcha_verification: "Пройдіть перевірку reCAPTCHA.",
    Heartspot_form_message:
      "Ваше повідомлення надіслано. Після перевірки командою heartspots ви отримаєте сповіщення.",
    NODATAMSG: "Для цього місця немає тренерів чи центрів",
    NOTRAINERMSG: "Для цього місця немає доступних тренерів",
    NOCENTERMSG: "Для цього місця немає доступних центрів",
  },
};

export function getConstants(locale) {
  if (localeConstants[locale]) return localeConstants[locale];
  return localeConstants.default;
}
